module.exports = __webpack_public_path__ + "static/media/red-crossmark.2d460ba1.svg";